var React = require('react');
var createClass = require('create-react-class');
var PropTypes = require('prop-types');
var Select = require('react-select').default;
var lodash = require('lodash').noConflict();
var labels = require('MemberJoinLabels');

var CredentialsSelect = createClass({
    displayName: 'CredentialsSelect',
    propTypes: {
        label: PropTypes.string,
        fieldName: PropTypes.string,
        recordId: PropTypes.number,
        changeFunction: PropTypes.func,
        credentialsList: PropTypes.array
    },
    getInitialState() {
        return {
            initialValue: this.props.initialValue,
            removeSelected: true
        };
    },

    handleSelectChange(values) {
        lodash.difference(values, this.props.initialValue).map((val) => {
            if (val) {
                this.props.changeFunction(this.props.fieldName, val, true);
            }
        });
    },

    handleBlur() {
        if (this.props.handleBlur) {
            this.props.handleBlur();
        }
    },

    getCredentialsArray() {
        return this.props.credentialsList.map((cred) => ({
            label: cred.Description,
            value: cred.Code
        }));
    },

    handleBlurEvent() {
        this.handleBlur();
        this.props.checkUserExistingModal();
    },

    render() {
        return (
            <div className={"section"}>
                <Select
                    backspaceRemoves={false}
                    tabSelectsValue={false}
                    scrollMenuIntoView={false}
                    backspaceToRemoveMessage={''}
                    closeOnSelect={false}
                    multi
                    onBlur={this.handleBlurEvent}
                    onChange={this.handleSelectChange}
                    options={this.getCredentialsArray()}
                    placeholder={labels.step2.selectCredentials}
                    removeSelected={this.state.removeSelected}
                    value={this.props.initialValue.join(',')}
                />
            </div>
        );
    }
});
module.exports = CredentialsSelect;